import { WritingBadge } from './WritingBadge';
import { BadgeId, BadgesStats } from '../Models';
import moment from 'moment';

export default class NewYearBadge extends WritingBadge {
  public readonly id = BadgeId.bauble;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    if (!stats.todaysPage) {
      return false;
    }

    const createdDate = moment(stats.todaysPage.createdAt).toDate();

    const day = createdDate.getDay();
    const month = createdDate.getMonth();

    return day === 1 && month === 1;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/bauble.ts